export interface Tq5PortCallsM {
  rows: Array<{
    port: string;
    activity: { value: string; label: string } | null;
    fromDate: Date | null;
    toDate: Date | null;
    [key: string]: string | { value: string; label: string } | Date | null;
  }>;
}

export const tq5PortCallsFormInit: Tq5PortCallsM = {
  rows: Array.from({ length: 15 }, () => ({
    port: "",
    activity: { value: "", label: "" },
    fromDate: null,
    toDate: null,
  })),
};

export const tq5Options = [
  { value: "Loading", label: "Loading" },
  { value: "Discharging", label: "Discharging" },
  { value: "Bunkering", label: "Bunkering" },
  { value: "Drydock", label: "Dry dock" },
  { value: "Other", label: "Other" },
];

export function mapSqlToTq5PortCallsForm(_portCalls: any): Tq5PortCallsM["rows"] {
  const portCalls = Array.from({ length: 15 }, (_, index) => {
    const pcItem = _portCalls[index] || {};

    return {
      port: pcItem.PORT || "",
      activity: {
        value: pcItem.ACTIVITY_VALUE || "",
        label: pcItem.ACTIVITY_LABEL || "",
      },
      fromDate: pcItem.FROM_DATE ? new Date(pcItem.FROM_DATE) : null,
      toDate: pcItem.TO_DATE ? new Date(pcItem.TO_DATE) : null,
    };
  });

  return portCalls;
}
